import { render, staticRenderFns } from "./epubread.vue?vue&type=template&id=55eec216&scoped=true&"
import script from "./epubread.vue?vue&type=script&lang=js&"
export * from "./epubread.vue?vue&type=script&lang=js&"
import style0 from "./epubread.vue?vue&type=style&index=0&id=55eec216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eec216",
  null
  
)

export default component.exports